import { useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";

const INITIAL = [
  { code: "DEMO10", type: "-10% grozam", active: true, used: 42 },
  { code: "PIEGADE0", type: "Bezmaksas piegāde", active: true, used: 17 },
  { code: "VASARA25", type: "-25% akcijas precēm", active: false, used: 96 },
];

export default function Discounts() {
  const [list, setList] = useState(INITIAL);
  const [code, setCode] = useState("");

  const add = (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    setList((p) => [{ code: code.trim().toUpperCase(), type: "-10% grozam", active: true, used: 0 }, ...p]);
    setCode("");
    toast.success("Atlaides kods izveidots (DEMO)");
  };
  const toggle = (c) => setList((p) => p.map((x) => (x.code === c ? { ...x, active: !x.active } : x)));
  const del = (c) => setList((p) => p.filter((x) => x.code !== c));

  return (
    <div data-testid="admin-discounts">
      <h1 className="text-2xl font-extrabold uppercase tracking-tight mb-5">Atlaides kodi</h1>
      <form onSubmit={add} className="flex gap-2 mb-5 max-w-md">
        <input value={code} onChange={(e) => setCode(e.target.value)} placeholder="Jauns kods, piem. RUDENS15" data-testid="discount-code-input"
          className="flex-1 h-10 px-3 border border-[#E2E2E2] text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#111111]" />
        <button type="submit" data-testid="discount-add-btn" className="bg-[#D0121A] hover:bg-[#A80D14] text-white text-sm font-bold px-4 flex items-center gap-1.5 transition-colors"><Plus size={15} /> Izveidot</button>
      </form>
      <div className="bg-white border border-[#E2E2E2]">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-xs uppercase tracking-wider text-[#6B6B6B] border-b border-[#E2E2E2]">
            <th className="p-3">Kods</th><th>Nosacījums</th><th className="text-center">Izmantots</th><th className="text-center">Statuss</th><th></th>
          </tr></thead>
          <tbody>
            {list.map((d) => (
              <tr key={d.code} className="border-b border-[#F5F5F5]" data-testid={`discount-row-${d.code}`}>
                <td className="p-3 font-extrabold">{d.code}</td>
                <td className="text-[#6B6B6B]">{d.type}</td>
                <td className="text-center">{d.used} reizes</td>
                <td className="text-center">
                  <button onClick={() => toggle(d.code)} data-testid={`discount-toggle-${d.code}`}
                    className={`text-[11px] font-bold px-2.5 py-1 transition-colors ${d.active ? "bg-[#1E9E45] text-white" : "bg-[#E2E2E2] text-[#6B6B6B]"}`}>
                    {d.active ? "Aktīvs" : "Izslēgts"}
                  </button>
                </td>
                <td className="p-3 text-right">
                  <button onClick={() => del(d.code)} data-testid={`discount-delete-${d.code}`} className="p-1.5 hover:bg-[#F5F5F5] text-[#D0121A]" aria-label="Dzēst"><Trash2 size={14} /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
